import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authApi = {
  login: (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data),
  register: (payload) => api.post("/auth/register", payload).then((r) => r.data),
  me: () => api.get("/auth/me").then((r) => r.data),
};

export const jobsApi = {
  list: () => api.get("/jobs").then((r) => r.data),
  create: (payload) => api.post("/jobs", payload).then((r) => r.data),
  get: (id) => api.get(`/jobs/${id}`).then((r) => r.data),
};

export const candidatesApi = {
  list: () => api.get("/candidates").then((r) => r.data),
  get: (id) => api.get(`/candidates/${id}`).then((r) => r.data),
};

export const applicationsApi = {
  list: (jobId) => api.get("/applications", { params: jobId ? { job_id: jobId } : {} }).then((r) => r.data),
  moveStage: (appId, stage) => api.patch(`/applications/${appId}/stage`, { stage }).then((r) => r.data),
};

export const analyticsApi = {
  overview: () => api.get("/analytics/overview").then((r) => r.data),
};

export const leadsApi = {
  list: (params) => api.get("/leads", { params }).then((r) => r.data),
  setStatus: (id, status) => api.patch(`/leads/${id}/status`, { status }).then((r) => r.data),
  resendAlert: (id) => api.post(`/leads/${id}/resend-alert`).then((r) => r.data),
  resumeUrl: (id) => `${API}/leads/${id}/resume`,
};

export const aiApi = {
  rank: (job_id, candidate_ids) => api.post("/ai/rank", { job_id, candidate_ids }).then((r) => r.data),
  outreach: (prompt, context) => api.post("/ai/draft-outreach", { prompt, context }).then((r) => r.data),
  summarize: (prompt) => api.post("/ai/summarize-feedback", { prompt }).then((r) => r.data),
  jd: (prompt) => api.post("/ai/draft-jd", { prompt }).then((r) => r.data),
};
